import '@washndry/scss/app-washndry.scss';

document.addEventListener( "DOMContentLoaded", function () {
})
